<template>
  <zm-button size='large' type="primary" round @click='goUser'>{{ ctaName }}</zm-button>
</template>
<script>
import { mapGetters } from 'vuex';
import { navigateToTargetPage } from '@/utils/modal-utils';

export default {
  props: {
    ctaName: String,
    isZp: Boolean,
    isZr: Boolean,
    isSeatManage: Boolean
  },
  computed: {
    ...mapGetters(['successConfig']),
  },
  methods: {
    goUser() {
      this.$tracking.buyInteraction('purchase confirmation', this.ctaName?.toLowerCase?.());
      let url = '/account/user';
      if (this.isZp) {
        url = '/pbx/page/telephone/phoneUsers#/users';
      }
      if (this.isZr) {
        url = '/location'
      }
      if (this.isSeatManage) {
        url = this.successConfig.zeLink + '/e/billing/seats/'
      }

      navigateToTargetPage(url);
    }
  }
}
</script>
